import { createContext } from 'react';
import type { AuthUser } from 'aws-amplify/auth';
import {
  SIGN_IN, SIGN_OUT, UPDATE_DATEPICKER, LOG_ACTIVE,
} from './constants/actions';

type StateType = {
  user: AuthUser | null;
  datePicker: {
    fromDate: Date | null;
    toDate: Date | null;
  };
  lastActive: {
    time: number;
  };
}

export const initialState: StateType = {
  user: null,
  datePicker: {
    toDate: null,
    fromDate: null,
  },
  lastActive: {
    time: 0,
  },
};

export const persistanceConfig = {
  namespace: 'dataPortal',
  stateKeys: ['lastActive'],
};

export type Action =
  | { type: typeof SIGN_IN; payload: { user: AuthUser; }; }
  | { type: typeof SIGN_OUT; }
  | { type: typeof UPDATE_DATEPICKER; payload: { fieldName: 'fromDate' | 'toDate'; date: Date | null; }; }
  | { type: typeof LOG_ACTIVE; payload: { time: number; }; };

export const reducer = (state: StateType, action: Action): StateType => {
  // console.log(action); // Uncomment for debug logs

  switch (action.type) {
    case SIGN_IN:
      return {
        ...state,
        user: action.payload.user,
      };
    case SIGN_OUT:
      return {
        ...state,
        user: null,
      };
    case UPDATE_DATEPICKER:
      return {
        ...state,
        datePicker: {
          ...state.datePicker,
          [action.payload.fieldName]: action.payload.date,
        },
      };
    case LOG_ACTIVE:
      return {
        ...state,
        lastActive: {
          time: action.payload.time,
        },
      };
    default:
      throw new Error(`unhandled action ${(action as { type: string; }).type}`);
  }
};

type StoreContextType = {
  state: StateType;
  dispatch: (action: Action) => void;
}

const emptyContext: StoreContextType = { state: initialState, dispatch: () => {} };

export const StoreContext = createContext(emptyContext);
